import { Injectable } from '@angular/core';
import * as forge from 'node-forge';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RSAEncryptionService {

  encrypt(data: string): string {
    const publicKey = forge.pki.publicKeyFromPem(environment.publicKey);
    const encrypted = publicKey.encrypt(data, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
    });
    return forge.util.encode64(encrypted);
  }
}
